import type { Ref } from 'vue';

import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import type { Permission } from '@modules/permissions/utils';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type { IReportPayload } from '../components/VReports/types';
import type { ReportType } from '../enums';
import {
  REPORT_DOWNLOAD_API_URL,
  REPORT_DOWNLOAD_MUTATION,
} from '../constants';

export default function useReportDownloadMutation(
  reportType: Ref<ReportType>,
  permission: Ref<Permission>,
  reportPayload: Ref<IReportPayload>,
): IContextMutationResult<
    void,
    Error,
    IDownloadListReportPayload
  > {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [REPORT_DOWNLOAD_MUTATION],
    mutationFn: (payload) => fetchPost<void>(
      REPORT_DOWNLOAD_API_URL,
      {
        ...payload,
        report: {
          ...reportPayload.value,
        },
      },
      {
        permission: permission.value,
        urlParams: {
          reportType: reportType.value,
        },
      },
    ),
  });
}
